import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataGrid from "react-data-grid";
import { supabase } from "../client/client";
import "react-data-grid/lib/styles.css";

const FetchSoftware = () => {
    const [data, setData]               = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters]         = useState({
        attendant:   "",
        title:       "",
        description: "",
        license:     "",
    });

    const columnsSoftware = [
        { key: "attendant",        name: "Encargado",           width: 250 },
        {
            key: "title",
            name: "Nombre",
            width: 150,
            renderCell: ({ row }) => (
                <Link to={`/equipos/${row.id_equipo}/editar`}>{row.title}</Link>
            ),
        },
        { key: "description",      name: "Descripción",         width: 400 },
        { key: "license",          name: "Licencia",            width: 200 },
        { key: "license_duration", name: "Duración de licencia", width: 250 },
        { key: "date_expiry",      name: "Fecha de caducidad",  width: 250 },
    ];

    // Fetch raw data once on mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data: licenseData, error: licenseError } = await supabase
                    .from("licencias").select("*");
                if (licenseError) throw licenseError;

                const licenseIds = licenseData.map((l) => l.id_equipo).filter(Boolean);
                if (licenseIds.length === 0) { setData([]); return; }

                const { data: equiposData, error: equiposError } = await supabase
                    .from("equipos").select("id, title, attendant").in("id", licenseIds);
                if (equiposError) throw equiposError;

                const combined = licenseData.map((license) => {
                    const equipo = equiposData.find((e) => e.id === license.id_equipo);
                    return {
                        ...license,
                        title:     equipo?.title     ?? (license.equipo_title    || (license.id_equipo ? "(equipo eliminado)" : "—")),
                        attendant: equipo?.attendant ?? (license.equipo_attendant || ""),
                    };
                });

                setData(combined);
            } catch (error) {
                console.error("Error fetching software data:", error.message);
            }
        };
        fetchData();
    }, []);

    // Apply filters locally whenever data or filters change
    useEffect(() => {
        const filtered = data.filter((row) =>
            Object.entries(filters).every(([key, value]) =>
                !value || (row[key] ?? "").toLowerCase().includes(value.toLowerCase())
            )
        );
        const sorted = filtered.slice().sort(
            (a, b) => new Date(a.date_expiry) - new Date(b.date_expiry)
        );
        setFilteredData(sorted);
    }, [data, filters]);

    const handleFilterChange = (filterName, value) => {
        setFilters((prev) => ({ ...prev, [filterName]: value }));
    };

    return (
        <>
            <div className="flex items-center gap-2 mb-4 mt-5">
                <input
                    type="text"
                    placeholder="Filtrar por encargado"
                    value={filters.attendant}
                    onChange={(e) => handleFilterChange("attendant", e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filtrar por nombre"
                    value={filters.title}
                    onChange={(e) => handleFilterChange("title", e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filtrar por descripción"
                    value={filters.description}
                    onChange={(e) => handleFilterChange("description", e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filtrar por licencia"
                    value={filters.license}
                    onChange={(e) => handleFilterChange("license", e.target.value)}
                />
            </div>
            <DataGrid
                rows={filteredData}
                columns={columnsSoftware}
                style={{ minHeight: 500 }}
                rowHeight={50}
                className="rdg-light"
            />
        </>
    );
};

export default FetchSoftware;
